<template>
  <div class="container-fluid">
    <div class="row top3">
       <div class="col-md-12 padding-left-md">
         <img class="leadLogo" src="../assets/Logo_white.png" width="210" height="60">
       </div>
     </div>
     <div class="row top15 bottom6">
      <div class="col-md-12">
        <p class="comingSoon">COMING SOON...</p>
      </div>
    </div>
     <div class="row">
       <div class="col-md-12">
         <p class="headline">The Chatbot for Property Managers</p>
       </div>
     </div>
     <div class="row">
       <div class="col-md-12">
         <p class="subline">Providing a custom 24/7 experience for prospects through artificial intelligence. Made to enhance the leasing process.</p>
       </div>
     </div>
     <div class="row">
      <div class="col-md-12 top3 bottom17 text-center">
        <input type="button" class="btn blueButton" value="Pre Order" onclick="window.open('https://forms.monday.com/forms/e657a7fa0f32e0705d6ef4a6d3c04ae2')"/>
      </div>
    </div>
     <div class="row whiteRow top3 bottom4">
       <div class="col-md-2"></div>
       <div class="col-md-6">
         <div class="row poweredByLogo">
           <img class="nesPic" src="../assets/NES_Logo_Powered_By.png" width="360" height="40">
         </div>
       </div>
       <div class="col-md-2">
         <input type="button" class="btn redButton" value="Request A Demo" onclick="window.open('https://www.leadmanaging.com/book-a-demo')"/>
       </div>
     </div>
     <div class="row greyRow top5 bottom13">
       <div class="col-md-12">
         <p class="greyLine">ChatManaging powered by National Efficiency Systems Inc. |
           <a href="https://www.leadmanaging.com/privacy-policy" target="_blank" class="whiteLink">Privacy Policy</a>
         </p>
       </div>
     </div>
   </div>
</template>

<script>
export default {
  name: 'LandingPage2',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media only screen and (max-width: 850px) {
  .col-md-2 {
    text-align: center;
  }

  .poweredByLogo {
    display: flex;
    justify-content: center;
  }
}

.top3 {
  padding-top: 3vh;
}

.top5 {
  padding-top: 5vh;
}

.top15 {
  padding-top: 15vh;
}

.top25 {
  padding-top: 25vh;
}

.bottom4 {
  padding-bottom: 4vh;
}

.bottom6 {
  padding-bottom: 7vh;
}

.bottom17 {
  padding-bottom: 17vh;
}

.bottom13 {
  padding-bottom: 13vh;
}

.bottom21 {
  padding-bottom: 26vh;
}

.whiteRow {
  background-color: #FFFFFF;
}

.greyRow {
  background-color: #363636;
}

.leadLogo {
  padding-top: 30px;
  position: absolute;
  margin-left: 15vw;
}

.headline {
  font-family: 'Yantramanav', sans-serif;
  font-style: normal;
  font-weight: 700;
  margin: 0;
  text-align: center;
  color: #FFFFFF;
  font-size: 50px;
}

.comingSoon {
  font-family: 'Yantramanav', sans-serif;
  font-style: normal;
  font-weight: 400;
  margin: 0;
  text-align: center;
  color: #FFFFFF;
  font-size: 55px;
}

.subline {
  font-family: 'Yantramanav', sans-serif;
  font-style: normal;
  font-weight: 400;
  margin: 0;
  text-align: center;
  color: #FFFFFF;
  font-size: 25px;
}

.greyLine {
  color: #FFFFFF;
  font-family: 'Yantramanav', sans-serif;
  font-style: normal;
  font-weight: 400;
  text-align: center;
  font-size: 18px;
}

.redButton {
  background-color: #FFFFFF;
  border-radius: 30px;
  border: 2px solid #e43a3f;
  font-family: 'Yantramanav', sans-serif;
  font-size: 17px !important;
  color: #e43a3f;
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 8px;
}

.blueButton {
  background-color: Transparent;
  border-radius: 30px;
  border: 2px solid #FFFFFF;
  font-family: 'Yantramanav', sans-serif;
  font-size: 17px !important;
  color: #FFFFFF;
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 8px;
}

.blueButton:hover {
  background-color: #FFFFFF;
  color: #50AAD6;
}

.redButton:hover {
  background-color: #e43a3f;
  color: white;
}

.whiteLink {
  color: #FFFFFF;
  text-decoration: underline;
  text-decoration-color: #FFFFFF;
}

.whiteLink:hover {
  color: grey;
  text-decoration-color: grey;
}

</style>



// WEBPACK FOOTER //
// src/components/LandingPage2.vue